const SMILEYS_PEOPLE = [
    { emoji: "👌🏿" },
    { emoji: "👌🏾" },
    { emoji: "👌🏽" },
    { emoji: "👌🏼" },
    { emoji: "👌🏻" },
    { emoji: "👌" },
    { emoji: "👍🏿" },
    { emoji: "👍🏾" },
    { emoji: "👍🏽" },
    { emoji: "👍🏼" },
    { emoji: "👍🏻" },
    { emoji: "👍" },
    { emoji: "👎🏿" },
    { emoji: "👎🏾" },
    { emoji: "👎🏽" },
    { emoji: "👎🏼" },
    { emoji: "👎🏻" },
    { emoji: "👎" },
    { emoji: "🙏🏿" },
    { emoji: "🙏🏾" },
    { emoji: "🙏🏽" },
    { emoji: "🙏🏼" },
    { emoji: "🙏🏻" },
    { emoji: "🙏" },
    { emoji: "🙌🏿" },
    { emoji: "🙌🏾" },
    { emoji: "🙌🏽" },
    { emoji: "🙌🏼" },
    { emoji: "🙌🏻" },
    { emoji: "🙌" },
    { emoji: "✌🏿" },
    { emoji: "✌🏾" },
    { emoji: "✌🏽" },
    { emoji: "✌🏼" },
    { emoji: "✌🏻" },
    { emoji: "✌️" },
    { emoji: "👏🏿" },
    { emoji: "👏🏾" },
    { emoji: "👏🏽" },
    { emoji: "👏🏼" },
    { emoji: "👏🏻" },
    { emoji: "👏" },
    { emoji: "✋🏿" },
    { emoji: "✋🏾" },
    { emoji: "✋🏽" },
    { emoji: "✋🏼" },
    { emoji: "✋🏻" },
    { emoji: "✋" },
    { emoji: "👉🏿" },
    { emoji: "👉🏾" },
    { emoji: "👉🏽" },
    { emoji: "👉🏼" },
    { emoji: "👉🏻" },
    { emoji: "👉" },
    { emoji: "👈🏿" },
    { emoji: "👈🏾" },
    { emoji: "👈🏽" },
    { emoji: "👈🏼" },
    { emoji: "👈🏻" },
    { emoji: "👈" },
    { emoji: "👇🏿" },
    { emoji: "👇🏾" },
    { emoji: "👇🏽" },
    { emoji: "👇🏼" },
    { emoji: "👇🏻" },
    { emoji: "👇" },
    { emoji: "👆🏿" },
    { emoji: "👆🏾" },
    { emoji: "👆🏽" },
    { emoji: "👆🏼" },
    { emoji: "👆🏻" },
    { emoji: "👆" },
    { emoji: "☝🏿" },
    { emoji: "☝🏾" },
    { emoji: "☝🏽" },
    { emoji: "☝🏼" },
    { emoji: "☝🏻" },
    { emoji: "☝️" },
    { emoji: "👊🏿" },
    { emoji: "👊🏾" },
    { emoji: "👊🏽" },
    { emoji: "👊🏼" },
    { emoji: "👊🏻" },
    { emoji: "👊" },
    { emoji: "💪🏿" },
    { emoji: "💪🏾" },
    { emoji: "💪🏽" },
    { emoji: "💪🏼" },
    { emoji: "💪🏻" },
    { emoji: "💪" },
    { emoji: "👋🏿" },
    { emoji: "👋🏾" },
    { emoji: "👋🏽" },
    { emoji: "👋🏼" },
    { emoji: "👋🏻" },
    { emoji: "👋" },
    { emoji: "✊🏿" },
    { emoji: "✊🏾" },
    { emoji: "✊🏽" },
    { emoji: "✊🏼" },
    { emoji: "✊🏻" },
    { emoji: "✊" },
    { emoji: "👐🏿" },
    { emoji: "👐🏾" },
    { emoji: "👐🏽" },
    { emoji: "👐🏼" },
    { emoji: "👐🏻" },
    { emoji: "👐" },
    { emoji: "🤘🏿" },
    { emoji: "🤘🏾" },
    { emoji: "🤘🏽" },
    { emoji: "🤘🏼" },
    { emoji: "🤘🏻" },
    { emoji: "🤘" },
    { emoji: "🖖🏿" },
    { emoji: "🖖🏾" },
    { emoji: "🖖🏽" },
    { emoji: "🖖🏼" },
    { emoji: "🖖🏻" },
    { emoji: "🖖" },
    { emoji: "🖕🏿" },
    { emoji: "🖕🏾" },
    { emoji: "🖕🏽" },
    { emoji: "🖕🏼" },
    { emoji: "🖕🏻" },
    { emoji: "🖕" },
    { emoji: "🖐🏿" },
    { emoji: "🖐🏾" },
    { emoji: "🖐🏽" },
    { emoji: "🖐🏼" },
    { emoji: "🖐🏻" },
    { emoji: "🖐" },
    { emoji: "✍🏿" },
    { emoji: "✍🏾" },
    { emoji: "✍🏽" },
    { emoji: "✍🏼" },
    { emoji: "✍🏻" },
    { emoji: "✍" },
    { emoji: "💅🏿" },
    { emoji: "💅🏾" },
    { emoji: "💅🏽" },
    { emoji: "💅🏼" },
    { emoji: "💅🏻" },
    { emoji: "💅" },
    { emoji: "😀" },
    { emoji: "😬" },
    { emoji: "😁" },
    { emoji: "😂" },
    { emoji: "😃" },
    { emoji: "😄" },
    { emoji: "🤣" },
    { emoji: "😅" },
    { emoji: "😆" },
    { emoji: "😇" },
    { emoji: "😉" },
    { emoji: "😊" },
    { emoji: "🙂" },
    { emoji: "🙃" },
    { emoji: "☺" },
    { emoji: "😋" },
    { emoji: "😌" },
    { emoji: "😍" },
    { emoji: "😘" },
    { emoji: "😗" },
    { emoji: "😙" },
    { emoji: "😚" },
    { emoji: "🤪" },
    { emoji: "😜" },
    { emoji: "😝" },
    { emoji: "😛" },
    { emoji: "🤑" },
    { emoji: "😎" },
    { emoji: "🤓" },
    { emoji: "🧐" },
    { emoji: "🤠" },
    { emoji: "🤗" },
    { emoji: "🤡" },
    { emoji: "😏" },
    { emoji: "😶" },
    { emoji: "😐" },
    { emoji: "😑" },
    { emoji: "😒" },
    { emoji: "🙄" },
    { emoji: "🤨" },
    { emoji: "🤔" },
    { emoji: "🤫" },
    { emoji: "🤭 " },
    { emoji: "🤥" },
    { emoji: "😳" },
    { emoji: "😞" },
    { emoji: "😟" },
    { emoji: "😠" },
    { emoji: "😡" },
    { emoji: "🤬" },
    { emoji: "😔" },
    { emoji: "😕" },
    { emoji: "🙁" },
    { emoji: "☹" },
    { emoji: "😣" },
    { emoji: "😖" },
    { emoji: "😫" },
    { emoji: "😩" },
    { emoji: "😤" },
    { emoji: "😮" },
    { emoji: "😱" },
    { emoji: "😨" },
    { emoji: "😰" },
    { emoji: "😯" },
    { emoji: "😦" },
    { emoji: "😧" },
    { emoji: "😢" },
    { emoji: "😥" },
    { emoji: "😪" },
    { emoji: "🤤" },
    { emoji: "😓" },
    { emoji: "😭" },
    { emoji: "🤩" },
    { emoji: "😵" },
    { emoji: "😲" },
    { emoji: "🤯" },
    { emoji: "🤐" },
    { emoji: "😷" },
    { emoji: "🤕" },
    { emoji: "🤒" },
    { emoji: "🤮" },
    { emoji: "🤢" },
    { emoji: "🤧" },
    { emoji: "😴" },
    { emoji: "💤" },
    { emoji: "😈" },
    { emoji: "👿" },
    { emoji: "👹" },
    { emoji: "👺" },
    { emoji: "💩" },
    { emoji: "👻" },
    { emoji: "💀" },
    { emoji: "☠" },
    { emoji: "👽" },
    { emoji: "🤖" },
    { emoji: "🎃" },
    { emoji: "😺" },
    { emoji: "😸" },
    { emoji: "😹" },
    { emoji: "😻" },
    { emoji: "😼" },
    { emoji: "😽" },
    { emoji: "🙀" },
    { emoji: "😿" },
    { emoji: "😾" },
    { emoji: "👄" },
    { emoji: "👅" },
    { emoji: "👂" },
    { emoji: "👃" },
    { emoji: "👁" },
    { emoji: "👀" },
    { emoji: "🧠" },
    { emoji: "👤" },
    { emoji: "👥" },
    { emoji: "🗣" },
    { emoji: "👶" },
    { emoji: "🧒" },
    { emoji: "👦" },
    { emoji: "👧" },
    { emoji: "🧑" },
    { emoji: "👨" },
    { emoji: "🧔" },
    { emoji: "👱‍♂️" },
    { emoji: "👩" },
    { emoji: "👱‍♀️" },
    { emoji: "🧓" },
    { emoji: "👴" },
    { emoji: "👵" },
    { emoji: "👲" },
    { emoji: "👳‍♀️" },
    { emoji: "👳‍♂️" },
    { emoji: "🧕" },
    { emoji: "👮♀️" },
    { emoji: "👮‍♂️" },
    { emoji: "👩‍🚒" },
    { emoji: "👨‍🚒" },
    { emoji: "👷‍♀️" },
    { emoji: "👷‍♂️" },
    { emoji: "👩‍🏭" },
    { emoji: "👨‍🏭" },
    { emoji: "👩‍🔧" },
    { emoji: "👨‍🔧" },
    { emoji: "👩‍🌾" },
    { emoji: "👨‍🌾" },
    { emoji: "👩‍🍳" },
    { emoji: "👨‍🍳" },
    { emoji: "👩‍🎤" },
    { emoji: "👨‍🎤" },
    { emoji: "👩‍🎨" },
    { emoji: "👨‍🎨" },
    { emoji: "👩‍🏫" },
    { emoji: "👨‍🏫" },
    { emoji: "👩‍🎓" },
    { emoji: "👨‍🎓" },
    { emoji: "👩‍💼" },
    { emoji: "👨‍💼" },
    { emoji: "👩‍💻" },
    { emoji: "👨‍💻" },
    { emoji: "👩‍🔬" },
    { emoji: "👨‍🔬" },
    { emoji: "👩‍🚀" },
    { emoji: "👨‍🚀" },
    { emoji: "👩‍⚕️" },
    { emoji: "👨‍⚕️" },
    { emoji: "👩‍⚖️" },
    { emoji: "👨‍⚖️" },
    { emoji: "👩‍✈️" },
    { emoji: "👨‍✈️" },
    { emoji: "💂‍♀️" },
    { emoji: "💂‍♂️" },
    { emoji: "🕵️‍♀️" },
    { emoji: "🕵️‍♂️" },
    { emoji: "🤶" },
    { emoji: "🎅" },
    { emoji: "👼" },
    { emoji: "👸" },
    { emoji: "🤴" },
    { emoji: "👰" },
    { emoji: "🤵‍♀️" },
    { emoji: "🤵" },
    { emoji: "🕴️‍♀️" },
    { emoji: "🕴" },
    { emoji: "🧙‍♀️" },
    { emoji: "🧙‍♂️" },
    { emoji: "🧝‍♀️" },
    { emoji: "🧝‍♂️" },
    { emoji: "🧚‍♀️" },
    { emoji: "🧚‍♂️" },
    { emoji: "🧞‍♀️" },
    { emoji: "🧞‍♂️" },
    { emoji: "🧜‍♀️" },
    { emoji: "🧜‍♂️" },
    { emoji: "🧛‍♀️" },
    { emoji: "🧛‍♂️" },
    { emoji: "🧟‍♀️" },
    { emoji: "🧟‍♂️" },
    { emoji: "🙇‍♀️" },
    { emoji: "🙇‍♂️" },
    { emoji: "💁‍♀️" },
    { emoji: "💁‍♂️" },
    { emoji: "🙅‍♀️" },
    { emoji: "🙅‍♂️" },
    { emoji: "🙆‍♀️" },
    { emoji: "🙆‍♂️" },
    { emoji: "🤷‍♀️" },
    { emoji: "🤷‍♂️" },
    { emoji: "🙋‍♀️" },
    { emoji: "🙋‍♂️" },
    { emoji: "🤦‍♀️" },
    { emoji: "🤦‍♂️" },
    { emoji: "🙎‍♀️" },
    { emoji: "🙎‍♂️" },
    { emoji: "🙍‍♀️" },
    { emoji: "🙍‍♂️" },
    { emoji: "💇‍♀️" },
    { emoji: "💇‍♂️" },
    { emoji: "💆‍♀️" },
    { emoji: "💆‍♂️" },
    { emoji: "🤰" },
    { emoji: "🤱" },
    { emoji: "🚶‍♀️" },
    { emoji: "🚶‍♂️" },
    { emoji: "🏃‍♀️" },
    { emoji: "🏃♂️" },
    { emoji: "💃" },
    { emoji: "🕺" },
    { emoji: "👯‍♀️" },
    { emoji: "👯‍♂️" },
    { emoji: "👫" },
    { emoji: "👬" },
    { emoji: "👭" },
    { emoji: "💑" },
    { emoji: "👩‍❤️‍👩" },
    { emoji: "👨‍❤️‍👨" },
    { emoji: "💏" },
    { emoji: "👩‍❤️‍💋‍👩" },
    { emoji: "👨‍❤️‍💋‍👨" },
    { emoji: "👪" },
    { emoji: "👨‍👩‍👧" },
    { emoji: "👨‍👩‍👧‍👦" },
    { emoji: "👨‍👩‍👦‍👦" },
    { emoji: "👨‍👩‍👧‍👧" },
    { emoji: "👩‍👩‍👦" },
    { emoji: "👩‍👩‍👧" },
    { emoji: "👩‍👩‍👧‍👦" },
    { emoji: "👩‍👩‍👦‍👦" },
    { emoji: "👩‍👩‍👧‍👧" },
    { emoji: "👨‍👨‍👦" },
    { emoji: "👨‍👨‍👧" },
    { emoji: "👨‍👨‍👧‍👦" },
    { emoji: "👨‍👨‍👦‍👦" },
    { emoji: "👨‍👨‍👧‍👧" },
    { emoji: "👩‍" },
    { emoji: "👨‍👦" },
    { emoji: "👚" },
    { emoji: "👕" },
    { emoji: "🧥" },
    { emoji: "👖" },
    { emoji: "👔" },
    { emoji: "👗" },
    { emoji: "👙" },
    { emoji: "👘" },
    { emoji: "💄" },
    { emoji: "💋" },
    { emoji: "👣" },
    { emoji: "🧦" },
    { emoji: "👠" },
    { emoji: "👡" },
    { emoji: "👢" },
    { emoji: "👞" },
    { emoji: "👟" },
    { emoji: "🧢" },
    { emoji: "👒" },
    { emoji: "🎩" },
    { emoji: "🎓" },
    { emoji: "👑" },
    { emoji: "⛑" },
    { emoji: "🎒" },
    { emoji: "👝" },
    { emoji: "👛" },
    { emoji: "👜" },
    { emoji: "💼" },
    { emoji: "👓" },
    { emoji: "🕶" },
    { emoji: "🧣" },
    { emoji: "🧤" },
    { emoji: "💍" },
    { emoji: "🌂" },
    { emoji: "☂" },
    { emoji: "👨‍👧 👨‍👧‍👦 👨‍👦‍👦 👨‍👧‍👧" },
    { emoji: "👩‍👧 👩‍👧‍👦 👩‍👦‍👦 👩‍👧‍👧" },
];
const ANIMALS_NATURE = [
    { emoji: "🐶" },
    { emoji: "🐱" },
    { emoji: "🐭" },
    { emoji: "🐹" },
    { emoji: "🐰" },
    { emoji: "🐻" },
    { emoji: "🐼" },
    { emoji: "🐨" },
    { emoji: "🐯" },
    { emoji: "🦁" },
    { emoji: "🐮" },
    { emoji: "🐷" },
    { emoji: "🐽" },
    { emoji: "🐸" },
    { emoji: "🐵" },
    { emoji: "🙈" },
    { emoji: "🙉" },
    { emoji: "🙊" },
    { emoji: "🐒" },
    { emoji: "🦍" },
    { emoji: "🐔" },
    { emoji: "🐧" },
    { emoji: "🐦" },
    { emoji: "🐤" },
    { emoji: "🐣" },
    { emoji: "🐥" },
    { emoji: "🐺" },
    { emoji: "🦊" },
    { emoji: "🐗" },
    { emoji: "🐴" },
    { emoji: "🦓" },
    { emoji: "🦒" },
    { emoji: "🦌" },
    { emoji: "🦄" },
    { emoji: "🐝" },
    { emoji: "🐛" },
    { emoji: "🦋" },
    { emoji: "🐌" },
    { emoji: "🐞" },
    { emoji: "🐜" },
    { emoji: "🦗" },
    { emoji: "🕷" },
    { emoji: "🕸" },
    { emoji: "🦂" },
    { emoji: "🐢" },
    { emoji: "🐍" },
    { emoji: "🦎" },
    { emoji: "🦀" },
    { emoji: "🦑" },
    { emoji: "🐙" },
    { emoji: "🦐" },
    { emoji: "🐠" },
    { emoji: "🐟" },
    { emoji: "🐡" },
    { emoji: "🐬" },
    { emoji: "🦈" },
    { emoji: "🐳" },
    { emoji: "🐋" },
    { emoji: "🐊" },
    { emoji: "🐆" },
    { emoji: "🐅" },
    { emoji: "🐃" },
    { emoji: "🐂" },
    { emoji: "🐄" },
    { emoji: "🐪" },
    { emoji: "🐫" },
    { emoji: "🐘" },
    { emoji: "🦏" },
    { emoji: "🐐" },
    { emoji: "🐏" },
    { emoji: "🐑" },
    { emoji: "🐎" },
    { emoji: "🐖" },
    { emoji: "🦇" },
    { emoji: "🐓" },
    { emoji: "🦃" },
    { emoji: "🕊" },
    { emoji: "🦅" },
    { emoji: "🦆" },
    { emoji: "🦉" },
    { emoji: "🐕" },
    { emoji: "🐩" },
    { emoji: "🐈" },
    { emoji: "🐇" },
    { emoji: "🐀" },
    { emoji: "🐁" },
    { emoji: "🐿" },
    { emoji: "🦔" },
    { emoji: "🐾" },
    { emoji: "🐉" },
    { emoji: "🐲" },
    { emoji: "🦕" },
    { emoji: "🦖" },
    { emoji: "🌵" },
    { emoji: "🎄" },
    { emoji: "🌲" },
    { emoji: "🌳" },
    { emoji: "🌴" },
    { emoji: "🌱" },
    { emoji: "🌿" },
    { emoji: "☘" },
    { emoji: "🍀" },
    { emoji: "🎍" },
    { emoji: "🎋" },
    { emoji: "🍃" },
    { emoji: "🍂" },
    { emoji: "🍁" },
    { emoji: "🌾" },
    { emoji: "🌺" },
    { emoji: "🌻" },
    { emoji: "🌹" },
    { emoji: "🥀" },
    { emoji: "🌷" },
    { emoji: "🌼" },
    { emoji: "🌸" },
    { emoji: "💐" },
    { emoji: "🍄" },
    { emoji: "🌰" },
    { emoji: "🐚" },
    { emoji: "🌎" },
    { emoji: "🌍" },
    { emoji: "🌏" },
    { emoji: "🌕" },
    { emoji: "🌖" },
    { emoji: "🌗" },
    { emoji: "🌘" },
    { emoji: "🌑" },
    { emoji: "🌒" },
    { emoji: "🌓" },
    { emoji: "🌔" },
    { emoji: "🌚" },
    { emoji: "🌝" },
    { emoji: "🌛" },
    { emoji: "🌜" },
    { emoji: "🌞" },
    { emoji: "🌙" },
    { emoji: "⭐" },
    { emoji: "🌟" },
    { emoji: "💫" },
    { emoji: "✨" },
    { emoji: "☄ " },
    { emoji: "🌤" },
    { emoji: "⛅" },
    { emoji: "🌥" },
    { emoji: "🌦" },
    { emoji: "☁" },
    { emoji: "🌧" },
    { emoji: "⛈" },
    { emoji: "🌩" },
    { emoji: "⚡" },
    { emoji: "🔥" },
    { emoji: "💥" },
    { emoji: "❄" },
    { emoji: "🌨" },
    { emoji: "☃" },
    { emoji: "⛄" },
    { emoji: "🌬" },
    { emoji: "💨" },
    { emoji: "🌪" },
    { emoji: "🌫" },
    { emoji: "☔" },
    { emoji: "💧" },
    { emoji: "💦" },
    { emoji: "🌊" },
];
const FOOD_DRINK = [
    { emoji: "🍏" },
    { emoji: "🍎" },
    { emoji: "🍐" },
    { emoji: "🍊" },
    { emoji: "🍋" },
    { emoji: "🍌" },
    { emoji: "🍉" },
    { emoji: "🍇" },
    { emoji: "🍓" },
    { emoji: "🍈" },
    { emoji: "🍒" },
    { emoji: "🍑" },
    { emoji: "🍍" },
    { emoji: "🥥" },
    { emoji: "🥝" },
    { emoji: "🍅" },
    { emoji: "🥑" },
    { emoji: "🍆" },
    { emoji: "🌶" },
    { emoji: "🥒" },
    { emoji: "🥦" },
    { emoji: "🌽" },
    { emoji: "🥕" },
    { emoji: "🥗" },
    { emoji: "🥔" },
    { emoji: "🍠" },
    { emoji: "🥜" },
    { emoji: "🍯" },
    { emoji: "🍞" },
    { emoji: "🥐" },
    { emoji: "🥖" },
    { emoji: "🥨" },
    { emoji: "🥞" },
    { emoji: "🧀" },
    { emoji: "🍗" },
    { emoji: "🍖" },
    { emoji: "🥩" },
    { emoji: "🍤" },
    { emoji: "🥚" },
    { emoji: "🍳" },
    { emoji: "🥓" },
    { emoji: "🍔" },
    { emoji: "🍟" },
    { emoji: "🌭" },
    { emoji: "🍕" },
    { emoji: "🍝" },
    { emoji: "🥪" },
    { emoji: "🥙" },
    { emoji: "🌮" },
    { emoji: "🌯" },
    { emoji: "🍜" },
    { emoji: "🥘" },
    { emoji: "🍲" },
    { emoji: "🥫" },
    { emoji: "🍥" },
    { emoji: "🍣" },
    { emoji: "🍱" },
    { emoji: "🍛" },
    { emoji: "🍙" },
    { emoji: "🍚" },
    { emoji: "🍘" },
    { emoji: "🥟" },
    { emoji: "🍢" },
    { emoji: "🍡" },
    { emoji: "🍧" },
    { emoji: "🍨" },
    { emoji: "🍦" },
    { emoji: "🍰" },
    { emoji: "🎂" },
    { emoji: "🥧" },
    { emoji: "🍮" },
    { emoji: "🍭" },
    { emoji: "🍬" },
    { emoji: "🍫" },
    { emoji: "🍿" },
    { emoji: "🍩" },
    { emoji: "🍪" },
    { emoji: "🥠" },
    { emoji: "☕" },
    { emoji: "🍵" },
    { emoji: "🥣" },
    { emoji: "🍼" },
    { emoji: "🥤" },
    { emoji: "🥛" },
    { emoji: "🍺" },
    { emoji: "🍻" },
    { emoji: "🍷" },
    { emoji: "🥂" },
    { emoji: "🥃" },
    { emoji: "🍸" },
    { emoji: "🍹" },
    { emoji: "🍾" },
    { emoji: "🍶" },
    { emoji: "🥄" },
    { emoji: "🍴" },
    { emoji: "🍽" },
    { emoji: "🥢" },
    { emoji: "🥡" },
];
const ACTIVITY = [
    { emoji: "⚽" },
    { emoji: "🏀" },
    { emoji: "🏈" },
    { emoji: "⚾" },
    { emoji: "🎾" },
    { emoji: "🏐" },
    { emoji: "🏉" },
    { emoji: "🎱" },
    { emoji: "🏓" },
    { emoji: "🏸" },
    { emoji: "🥅" },
    { emoji: "🏒" },
    { emoji: "🏑" },
    { emoji: "🏏" },
    { emoji: "🥌" },
    { emoji: "⛳" },
    { emoji: "🏹" },
    { emoji: "🎣" },
    { emoji: "🥊" },
    { emoji: "🥋" },
    { emoji: "⛸" },
    { emoji: "🎿" },
    { emoji: "🛷" },
    { emoji: "⛷" },
    { emoji: "🏂" },
    { emoji: "🏋️‍♀️" },
    { emoji: "🏋️‍♂️" },
    { emoji: "🤺" },
    { emoji: "🤼‍♀️" },
    { emoji: "🤼‍♂️" },
    { emoji: "🤸‍♀️" },
    { emoji: "🤸‍♂️" },
    { emoji: "⛹️‍♀️" },
    { emoji: "⛹️‍♂️" },
    { emoji: "🤾‍♀️" },
    { emoji: "🤾‍♂️" },
    { emoji: "🧗‍♀️" },
    { emoji: "🧗‍♂️" },
    { emoji: "🏌️‍♀️" },
    { emoji: "🏌️‍♂️" },
    { emoji: "🧘‍♀️" },
    { emoji: "🧘‍♂️" },
    { emoji: "🧖‍♀️" },
    { emoji: "🧖‍♂️" },
    { emoji: "🏄‍♀️" },
    { emoji: "🏄‍♂️" },
    { emoji: "🏊‍♀️" },
    { emoji: "🏊‍♂️" },
    { emoji: "🤽‍♀️" },
    { emoji: "🤽‍♂️" },
    { emoji: "🚣‍♀️" },
    { emoji: "🚣‍♂️" },
    { emoji: "🏇" },
    { emoji: "🚴‍♀️" },
    { emoji: "🚴‍♂️" },
    { emoji: "🚵‍♀️" },
    { emoji: "🚵‍♂️" },
    { emoji: "🎽" },
    { emoji: "🎖" },
    { emoji: "🏅" },
    { emoji: "🥇" },
    { emoji: "🥈" },
    { emoji: "🥉" },
    { emoji: "🏆" },
    { emoji: "🏵" },
    { emoji: "🎗" },
    { emoji: "🎫" },
    { emoji: "🎟" },
    { emoji: "🎪" },
    { emoji: "🤹‍♀️" },
    { emoji: "🤹‍♂️" },
    { emoji: "🎭" },
    { emoji: "🎨" },
    { emoji: "🎬" },
    { emoji: "🎤" },
    { emoji: "🎧" },
    { emoji: "🎼" },
    { emoji: "🎹" },
    { emoji: "🥁" },
    { emoji: "🎷" },
    { emoji: "🎺" },
    { emoji: "🎸" },
    { emoji: "🎻" },
    { emoji: "🎲" },
    { emoji: "🎯" },
    { emoji: "🎳" },
    { emoji: "🎮" },
    { emoji: "👾" },
    { emoji: "🎰" },
];
const TRAVEL_PLACES = [
    { emoji: "🚗" },
    { emoji: "🚕" },
    { emoji: "🚙" },
    { emoji: "🚌" },
    { emoji: "🚎" },
    { emoji: "🏎" },
    { emoji: "🚓" },
    { emoji: "🚑" },
    { emoji: "🚒" },
    { emoji: "🚐" },
    { emoji: "🚚" },
    { emoji: "🚛" },
    { emoji: "🚜" },
    { emoji: "🏍" },
    { emoji: "🛵" },
    { emoji: "🚲" },
    { emoji: "🛴" },
    { emoji: "🚨" },
    { emoji: "🚔" },
    { emoji: "🚍" },
    { emoji: "🚘" },
    { emoji: "🚖" },
    { emoji: "🚡" },
    { emoji: "🚠" },
    { emoji: "🚟" },
    { emoji: "🚃" },
    { emoji: "🚋" },
    { emoji: "🚝" },
    { emoji: "🚄" },
    { emoji: "🚅" },
    { emoji: "🚈" },
    { emoji: "🚞" },
    { emoji: "🚂" },
    { emoji: "🚆" },
    { emoji: "🚇" },
    { emoji: "🚊" },
    { emoji: "🚉" },
    { emoji: "🚁" },
    { emoji: "🛩" },
    { emoji: "✈" },
    { emoji: "🛫" },
    { emoji: "🛬" },
    { emoji: "🛶" },
    { emoji: "⛵" },
    { emoji: "🛥" },
    { emoji: "🚤" },
    { emoji: "⛴" },
    { emoji: "🛳" },
    { emoji: "🚀" },
    { emoji: "🛸" },
    { emoji: "🛰" },
    { emoji: "💺" },
    { emoji: "⚓" },
    { emoji: "🚧" },
    { emoji: "⛽" },
    { emoji: "🚏" },
    { emoji: "🚦" },
    { emoji: "🚥" },
    { emoji: "🛑" },
    { emoji: "🚢" },
    { emoji: "🎡" },
    { emoji: "🎢" },
    { emoji: "🎠" },
    { emoji: "🏗" },
    { emoji: "🌁" },
    { emoji: "🗼" },
    { emoji: "🏭" },
    { emoji: "⛲" },
    { emoji: "🎑" },
    { emoji: "⛰" },
    { emoji: "🏔" },
    { emoji: "🗻" },
    { emoji: "🌋" },
    { emoji: "🗾" },
    { emoji: "🏕" },
    { emoji: "⛺" },
    { emoji: "🏞" },
    { emoji: "🛣" },
    { emoji: "🛤" },
    { emoji: "🌅" },
    { emoji: "🌄" },
    { emoji: "🏜" },
    { emoji: "🏖" },
    { emoji: "🏝" },
    { emoji: "🌇" },
    { emoji: "🌆" },
    { emoji: "🏙" },
    { emoji: "🌃" },
    { emoji: "🌉" },
    { emoji: "🌌" },
    { emoji: "🌠" },
    { emoji: "🎇" },
    { emoji: "🎆" },
    { emoji: "🌈" },
    { emoji: "🏘" },
    { emoji: "🏰" },
    { emoji: "🏯" },
    { emoji: "🏟" },
    { emoji: "🗽" },
    { emoji: "🏠" },
    { emoji: "🏡" },
    { emoji: "🏚" },
    { emoji: "🏢" },
    { emoji: "🏬" },
    { emoji: "🏣" },
    { emoji: "🏤" },
    { emoji: "🏥" },
    { emoji: "🏦" },
    { emoji: "🏨" },
    { emoji: "🏪" },
    { emoji: "🏫" },
    { emoji: "🏩" },
    { emoji: "💒" },
    { emoji: "🏛" },
    { emoji: "⛪" },
    { emoji: "🕌" },
    { emoji: "🕍" },
    { emoji: "🕋" },
    { emoji: "⛩" },
];
const OBJECTS = [
    { emoji: "⌚" },
    { emoji: "📱" },
    { emoji: "📲" },
    { emoji: "💻" },
    { emoji: "⌨" },
    { emoji: "🖥" },
    { emoji: "🖨" },
    { emoji: "🖱" },
    { emoji: "🖲" },
    { emoji: "🕹" },
    { emoji: "🗜" },
    { emoji: "💽" },
    { emoji: "💾" },
    { emoji: "💿" },
    { emoji: "📀" },
    { emoji: "📼" },
    { emoji: "📷" },
    { emoji: "📸" },
    { emoji: "📹" },
    { emoji: "🎥" },
    { emoji: "📽" },
    { emoji: "🎞" },
    { emoji: "📞" },
    { emoji: "☎" },
    { emoji: "📟" },
    { emoji: "📠" },
    { emoji: "📺" },
    { emoji: "📻" },
    { emoji: "🎙" },
    { emoji: "🎚" },
    { emoji: "🎛" },
    { emoji: "⏱" },
    { emoji: "⏲" },
    { emoji: "⏰" },
    { emoji: "🕰" },
    { emoji: "⏳" },
    { emoji: "⌛" },
    { emoji: "📡" },
    { emoji: "🔋" },
    { emoji: "🔌" },
    { emoji: "💡" },
    { emoji: "🔦" },
    { emoji: "🕯" },
    { emoji: "🗑" },
    { emoji: "🛢" },
    { emoji: "🛒" },
    { emoji: "💸" },
    { emoji: "💵" },
    { emoji: "💴" },
    { emoji: "💶" },
    { emoji: "💷" },
    { emoji: "💰" },
    { emoji: "💳" },
    { emoji: "💎" },
    { emoji: "⚖" },
    { emoji: "🔧" },
    { emoji: "🔨" },
    { emoji: "⚒" },
    { emoji: "🛠" },
    { emoji: "⛏" },
    { emoji: "🔩" },
    { emoji: "⚙" },
    { emoji: "⛓" },
    { emoji: "🔫" },
    { emoji: "💣" },
    { emoji: "🔪" },
    { emoji: "🗡" },
    { emoji: "⚔" },
    { emoji: "🛡" },
    { emoji: "🚬" },
    { emoji: "⚰" },
    { emoji: "⚱" },
    { emoji: "🏺" },
    { emoji: "🔮" },
    { emoji: "📿" },
    { emoji: "💈" },
    { emoji: "⚗" },
    { emoji: "🔭" },
    { emoji: "🔬" },
    { emoji: "🕳" },
    { emoji: "💊" },
    { emoji: "💉" },
    { emoji: "🌡" },
    { emoji: "🏷" },
    { emoji: "🔖" },
    { emoji: "🚽" },
    { emoji: "🚿" },
    { emoji: "🛁" },
    { emoji: "🛀" },
    { emoji: "🔑" },
    { emoji: "🗝" },
    { emoji: "🛋" },
    { emoji: "🛌" },
    { emoji: "🛏" },
    { emoji: "🚪" },
    { emoji: "🛎" },
    { emoji: "🖼" },
    { emoji: "🗺" },
    { emoji: "⛱" },
    { emoji: "🗿" },
    { emoji: "🛍" },
    { emoji: "🎈" },
    { emoji: "🎏" },
    { emoji: "🎀" },
    { emoji: "🎁" },
    { emoji: "🎊" },
    { emoji: "🎉" },
    { emoji: "🎎" },
    { emoji: "🎐" },
    { emoji: "🏮" },
    { emoji: "✉" },
    { emoji: "📩" },
    { emoji: "📨" },
    { emoji: "📧" },
    { emoji: "💌" },
    { emoji: "📮" },
    { emoji: "📪" },
    { emoji: "📫" },
    { emoji: "📬" },
    { emoji: "📭" },
    { emoji: "📦" },
    { emoji: "📯" },
    { emoji: "📥" },
    { emoji: "📤" },
    { emoji: "📜" },
    { emoji: "📃" },
    { emoji: "📑" },
    { emoji: "📊" },
    { emoji: "📈" },
    { emoji: "📉" },
    { emoji: "📄" },
    { emoji: "📅" },
    { emoji: "📆" },
    { emoji: "🗓" },
    { emoji: "📇" },
    { emoji: "🗃" },
    { emoji: "🗳" },
    { emoji: "🗄" },
    { emoji: "📋" },
    { emoji: "🗒" },
    { emoji: "📁" },
    { emoji: "📂" },
    { emoji: "🗂" },
    { emoji: "🗞" },
    { emoji: "📰" },
    { emoji: "📓" },
    { emoji: "📕" },
    { emoji: "📗" },
    { emoji: "📘" },
    { emoji: "📙" },
    { emoji: "📔" },
    { emoji: "📒" },
    { emoji: "📚" },
    { emoji: "📖" },
    { emoji: "🔗" },
    { emoji: "📎" },
    { emoji: "🖇" },
    { emoji: "✂" },
    { emoji: "📐" },
    { emoji: "📏" },
    { emoji: "📌" },
    { emoji: "📍" },
    { emoji: "🔐" },
    { emoji: "🔒" },
    { emoji: "🔓" },
    { emoji: "🔏" },
    { emoji: "🖊" },
    { emoji: "🖋" },
    { emoji: "✒" },
    { emoji: "📝" },
    { emoji: "✏" },
    { emoji: "🖍" },
    { emoji: "🖌" },
    { emoji: "🔍" },
    { emoji: "🔎" },
];
const SYMBOLS = [
    { emoji: "❤" },
    { emoji: "🧡" },
    { emoji: "💛" },
    { emoji: "💚" },
    { emoji: "💙" },
    { emoji: "💜" },
    { emoji: "🖤" },
    { emoji: "💔" },
    { emoji: "❣" },
    { emoji: "💕" },
    { emoji: "💞" },
    { emoji: "💓" },
    { emoji: "💗" },
    { emoji: "💖" },
    { emoji: "💘" },
    { emoji: "💝" },
    { emoji: "💟" },
    { emoji: "☮" },
    { emoji: "✝" },
    { emoji: "☪" },
    { emoji: "🕉" },
    { emoji: "☸" },
    { emoji: "✡" },
    { emoji: "🔯" },
    { emoji: "🕎" },
    { emoji: "☯" },
    { emoji: "☦" },
    { emoji: "🛐" },
    { emoji: "⛎" },
    { emoji: "♈" },
    { emoji: "♉" },
    { emoji: "♊" },
    { emoji: "♋" },
    { emoji: "♌" },
    { emoji: "♍" },
    { emoji: "♎" },
    { emoji: "♏" },
    { emoji: "♐" },
    { emoji: "♑" },
    { emoji: "♒" },
    { emoji: "♓" },
    { emoji: "🆔" },
    { emoji: "⚛" },
    { emoji: "⚕" },
    { emoji: "☢" },
    { emoji: "☣" },
    { emoji: "📴" },
    { emoji: "📳" },
    { emoji: "🈶" },
    { emoji: "🈚" },
    { emoji: "🈸" },
    { emoji: "🈺" },
    { emoji: "🈷" },
    { emoji: "✴" },
    { emoji: "🆚" },
    { emoji: "🉑" },
    { emoji: "💮" },
    { emoji: "🉐" },
    { emoji: "㊙" },
    { emoji: "㊗" },
    { emoji: "🈴" },
    { emoji: "🈵" },
    { emoji: "🈹" },
    { emoji: "🈲" },
    { emoji: "🅰" },
    { emoji: "🅱" },
    { emoji: "🆎" },
    { emoji: "🆑" },
    { emoji: "🅾" },
    { emoji: "🆘" },
    { emoji: "⛔" },
    { emoji: "📛" },
    { emoji: "🚫" },
    { emoji: "❌" },
    { emoji: "⭕" },
    { emoji: "💢" },
    { emoji: "♨" },
    { emoji: "🚷" },
    { emoji: "🚯" },
    { emoji: "🚳" },
    { emoji: "🚱" },
    { emoji: "🔞" },
    { emoji: "📵" },
    { emoji: "🚭" },
    { emoji: "❗" },
    { emoji: "❕" },
    { emoji: "❓" },
    { emoji: "❔" },
    { emoji: "‼" },
    { emoji: "⁉" },
    { emoji: "💯" },
    { emoji: "🔅" },
    { emoji: "🔆" },
    { emoji: "🔱" },
    { emoji: "⚜" },
    { emoji: "〽" },
    { emoji: "⚠" },
    { emoji: "🚸" },
    { emoji: "🔰" },
    { emoji: "♻" },
    { emoji: "🈯" },
    { emoji: "💹" },
    { emoji: "❇" },
    { emoji: "✳" },
    { emoji: "❎" },
    { emoji: "✅" },
    { emoji: "💠" },
    { emoji: "🌀" },
    { emoji: "➿" },
    { emoji: "🌐" },
    { emoji: "Ⓜ" },
    { emoji: "🏧" },
    { emoji: "🚾" },
    { emoji: "♿" },
    { emoji: "🅿" },
    { emoji: "🈳" },
    { emoji: "🈂" },
    { emoji: "🛂" },
    { emoji: "🛃" },
    { emoji: "🛄" },
    { emoji: "🛅" },
    { emoji: "🚰" },
    { emoji: "🚹" },
    { emoji: "♂" },
    { emoji: "🚺" },
    { emoji: "♀" },
    { emoji: "🚼" },
    { emoji: "🚻" },
    { emoji: "🚮" },
    { emoji: "🎦" },
    { emoji: "📶" },
    { emoji: "🈁" },
    { emoji: "🆖" },
    { emoji: "🆗" },
    { emoji: "🆙" },
    { emoji: "🆒" },
    { emoji: "🆕" },
    { emoji: "🆓" },
    { emoji: "0⃣" },
    { emoji: "1⃣" },
    { emoji: "2⃣" },
    { emoji: "3⃣" },
    { emoji: "4⃣" },
    { emoji: "5⃣" },
    { emoji: "6⃣" },
    { emoji: "7⃣" },
    { emoji: "8⃣" },
    { emoji: "9⃣" },
    { emoji: "🔟" },
    { emoji: "🔢" },
    { emoji: "▶" },
    { emoji: "⏸" },
    { emoji: "⏯" },
    { emoji: "⏹" },
    { emoji: "⏺" },
    { emoji: "⏏" },
    { emoji: "⏭" },
    { emoji: "⏮" },
    { emoji: "⏩" },
    { emoji: "⏪" },
    { emoji: "🔀" },
    { emoji: "🔁" },
    { emoji: "🔂" },
    { emoji: "◀" },
    { emoji: "🔼" },
    { emoji: "🔽" },
    { emoji: "⏫" },
    { emoji: "⏬" },
    { emoji: "➡" },
    { emoji: "⬅" },
    { emoji: "⬆" },
    { emoji: "⬇" },
    { emoji: "↗" },
    { emoji: "↘" },
    { emoji: "↙" },
    { emoji: "↖" },
    { emoji: "↕" },
    { emoji: "↔" },
    { emoji: "🔄" },
    { emoji: "↪" },
    { emoji: "↩" },
    { emoji: "🔃" },
    { emoji: "⤴" },
    { emoji: "⤵" },
    { emoji: "#⃣" },
    { emoji: "*⃣" },
    { emoji: "ℹ" },
    { emoji: "🔤" },
    { emoji: "🔡" },
    { emoji: "🔠" },
    { emoji: "🔣" },
    { emoji: "🎵" },
    { emoji: "🎶" },
    { emoji: "〰" },
    { emoji: "➰" },
    { emoji: "✔" },
    { emoji: "➕" },
    { emoji: "➖" },
    { emoji: "➗" },
    { emoji: "✖" },
    { emoji: "💲" },
    { emoji: "💱" },
    { emoji: "🔚" },
    { emoji: "🔙" },
    { emoji: "🔛" },
    { emoji: "🔝" },
    { emoji: "🔜" },
    { emoji: "☑" },
    { emoji: "🔘" },
    { emoji: "⚪" },
    { emoji: "⚫" },
    { emoji: "🔴" },
    { emoji: "🔵" },
    { emoji: "🔸" },
    { emoji: "🔹" },
    { emoji: "🔶" },
    { emoji: "🔷" },
    { emoji: "🔺" },
    { emoji: "▪" },
    { emoji: "▫" },
    { emoji: "⬛" },
    { emoji: "⬜" },
    { emoji: "🔻" },
    { emoji: "◼" },
    { emoji: "◻" },
    { emoji: "◾" },
    { emoji: "◽" },
    { emoji: "🔲" },
    { emoji: "🔳" },
    { emoji: "🔈" },
    { emoji: "🔉" },
    { emoji: "🔊" },
    { emoji: "🔇" },
    { emoji: "📣" },
    { emoji: "📢" },
    { emoji: "🔔" },
    { emoji: "🔕" },
    { emoji: "🃏" },
    { emoji: "🀄" },
    { emoji: "♠" },
    { emoji: "♣" },
    { emoji: "♥" },
    { emoji: "♦" },
    { emoji: "🎴" },
    { emoji: "👁‍🗨" },
    { emoji: "🗨" },
    { emoji: "💭" },
    { emoji: "🗯" },
    { emoji: "💬" },
    { emoji: "🕐" },
    { emoji: "🕑" },
    { emoji: "🕒" },
    { emoji: "🕓" },
    { emoji: "🕔" },
    { emoji: "🕕" },
    { emoji: "🕖" },
    { emoji: "🕗" },
    { emoji: "🕘" },
    { emoji: "🕙" },
    { emoji: "🕚" },
    { emoji: "🕛" },
    { emoji: "🕜" },
    { emoji: "🕝" },
    { emoji: "🕞" },
    { emoji: "🕟" },
    { emoji: "🕠" },
    { emoji: "🕡" },
    { emoji: "🕢" },
    { emoji: "🕣" },
    { emoji: "🕤" },
    { emoji: "🕥" },
    { emoji: "🕦" },
    { emoji: "🕧" },
];
const FLAGS = [
    { emoji: "🏳" },
    { emoji: "🏴" },
    { emoji: "🏁" },
    { emoji: "🚩" },
    { emoji: "🎌" },
    { emoji: "🏳️‍🌈" },
    { emoji: "🇦🇨" },
    { emoji: "🇦🇩" },
    { emoji: "🇦🇪" },
    { emoji: "🇦🇫" },
    { emoji: "🇦🇬" },
    { emoji: "🇦🇮" },
    { emoji: "🇦🇱" },
    { emoji: "🇦🇲" },
    { emoji: "🇦🇴" },
    { emoji: "🇦🇶" },
    { emoji: "🇦🇷" },
    { emoji: "🇦🇸" },
    { emoji: "🇦🇹" },
    { emoji: "🇦🇺" },
    { emoji: "🇦🇼" },
    { emoji: "🇦🇽" },
    { emoji: "🇦🇿" },
    { emoji: "🇧🇦" },
    { emoji: "🇧🇧" },
    { emoji: "🇧🇩" },
    { emoji: "🇧🇪" },
    { emoji: "🇧🇫" },
    { emoji: "🇧🇬" },
    { emoji: "🇧🇭" },
    { emoji: "🇧🇮" },
    { emoji: "🇧🇯" },
    { emoji: "🇧🇱" },
    { emoji: "🇧🇲" },
    { emoji: "🇧🇳" },
    { emoji: "🇧🇴" },
    { emoji: "🇧🇶" },
    { emoji: "🇧🇷" },
    { emoji: "🇧🇸" },
    { emoji: "🇧🇹" },
    { emoji: "🇧🇼" },
    { emoji: "🇧🇾" },
    { emoji: "🇧🇿" },
    { emoji: "🇨🇦" },
    { emoji: "🇨🇨" },
    { emoji: "🇨🇩" },
    { emoji: "🇨🇫" },
    { emoji: "🇨🇬" },
    { emoji: "🇨🇭" },
    { emoji: "🇨🇮" },
    { emoji: "🇨🇰" },
    { emoji: "🇨🇱" },
    { emoji: "🇨🇲" },
    { emoji: "🇨🇳" },
    { emoji: "🇨🇴" },
    { emoji: "🇨🇷" },
    { emoji: "🇨🇺" },
    { emoji: "🇨🇻" },
    { emoji: "🇨🇼" },
    { emoji: "🇨🇽" },
    { emoji: "🇨🇾" },
    { emoji: "🇨🇿" },
    { emoji: "🇩🇪" },
    { emoji: "🇩🇯" },
    { emoji: "🇩🇰" },
    { emoji: "🇩🇲" },
    { emoji: "🇩🇴" },
    { emoji: "🇩🇿" },
    { emoji: "🇪🇨" },
    { emoji: "🏴󠁧󠁢󠁥󠁮󠁧󠁿" },
    { emoji: "🇪🇪" },
    { emoji: "🇪🇬" },
    { emoji: "🇪🇭" },
    { emoji: "🇪🇷" },
    { emoji: "🇪🇸" },
    { emoji: "🇪🇹" },
    { emoji: "🇪🇺" },
    { emoji: "🇫🇮" },
    { emoji: "🇫🇯" },
    { emoji: "🇫🇰" },
    { emoji: "🇫🇲" },
    { emoji: "🇫🇴" },
    { emoji: "🇫🇷" },
    { emoji: "🇬🇦" },
    { emoji: "🇬🇧" },
    { emoji: "🇬🇩" },
    { emoji: "🇬🇪" },
    { emoji: "🇬🇫" },
    { emoji: "🇬🇬" },
    { emoji: "🇬🇭" },
    { emoji: "🇬🇮" },
    { emoji: "🇬🇱" },
    { emoji: "🇬🇲" },
    { emoji: "🇬🇳" },
    { emoji: "🇬🇵" },
    { emoji: "🇬🇶" },
    { emoji: "🇬🇷" },
    { emoji: "🇬🇸" },
    { emoji: "🇬🇹" },
    { emoji: "🇬🇺" },
    { emoji: "🇬🇼" },
    { emoji: "🇬🇾" },
    { emoji: "🇭🇰" },
    { emoji: "🇭🇳" },
    { emoji: "🇭🇷" },
    { emoji: "🇭🇹" },
    { emoji: "🇭🇺" },
    { emoji: "🇮🇨" },
    { emoji: "🇮🇩" },
    { emoji: "🇮🇪" },
    { emoji: "🇮🇱" },
    { emoji: "🇮🇲" },
    { emoji: "🇮🇳" },
    { emoji: "🇮🇴" },
    { emoji: "🇮🇶" },
    { emoji: "🇮🇷" },
    { emoji: "🇮🇸" },
    { emoji: "🇮🇹" },
    { emoji: "🇯🇪" },
    { emoji: "🇯🇲" },
    { emoji: "🇯🇴" },
    { emoji: "🇯🇵" },
    { emoji: "🇰🇪" },
    { emoji: "🇰🇬" },
    { emoji: "🇰🇭" },
    { emoji: "🇰🇮" },
    { emoji: "🇰🇲" },
    { emoji: "🇰🇳" },
    { emoji: "🇰🇵" },
    { emoji: "🇰🇷" },
    { emoji: "🇰🇼" },
    { emoji: "🇰🇾" },
    { emoji: "🇰🇿" },
    { emoji: "🇱🇦" },
    { emoji: "🇱🇧" },
    { emoji: "🇱🇨" },
    { emoji: "🇱🇮" },
    { emoji: "🇱🇰" },
    { emoji: "🇱🇷" },
    { emoji: "🇱🇸" },
    { emoji: "🇱🇹" },
    { emoji: "🇱🇺" },
    { emoji: "🇱🇻" },
    { emoji: "🇱🇾" },
    { emoji: "🇲🇦" },
    { emoji: "🇲🇨" },
    { emoji: "🇲🇩" },
    { emoji: "🇲🇪" },
    { emoji: "🇲🇬" },
    { emoji: "🇲🇭" },
    { emoji: "🇲🇰" },
    { emoji: "🇲🇱" },
    { emoji: "🇲🇲" },
    { emoji: "🇲🇳" },
    { emoji: "🇲🇴" },
    { emoji: "🇲🇵" },
    { emoji: "🇲🇶" },
    { emoji: "🇲🇷" },
    { emoji: "🇲🇸" },
    { emoji: "🇲🇹" },
    { emoji: "🇲🇺" },
    { emoji: "🇲🇻" },
    { emoji: "🇲🇼" },
    { emoji: "🇲🇽" },
    { emoji: "🇲🇾" },
    { emoji: "🇲🇿" },
    { emoji: "🇳🇦" },
    { emoji: "🇳🇨" },
    { emoji: "🇳🇪" },
    { emoji: "🇳🇫" },
    { emoji: "🇳🇬" },
    { emoji: "🇳🇮" },
    { emoji: "🇳🇱" },
    { emoji: "🇳🇴" },
    { emoji: "🇳🇵" },
    { emoji: "🇳🇷" },
    { emoji: "🇳🇺" },
    { emoji: "🇳🇿" },
    { emoji: "🇴🇲" },
    { emoji: "🇵🇦" },
    { emoji: "🇵🇪" },
    { emoji: "🇵🇫" },
    { emoji: "🇵🇬" },
    { emoji: "🇵🇭" },
    { emoji: "🇵🇰" },
    { emoji: "🇵🇱" },
    { emoji: "🇵🇲" },
    { emoji: "🇵🇳" },
    { emoji: "🇵🇷" },
    { emoji: "🇵🇸" },
    { emoji: "🇵🇹" },
    { emoji: "🇵🇼" },
    { emoji: "🇵🇾" },
    { emoji: "🇶🇦" },
    { emoji: "🇷🇪" },
    { emoji: "🇷🇴" },
    { emoji: "🇷🇸" },
    { emoji: "🇷🇺" },
    { emoji: "🇷🇼" },
    { emoji: "🇸🇦" },
    { emoji: "🏴󠁧󠁢󠁳󠁣󠁴󠁿" },
    { emoji: "🇸🇧" },
    { emoji: "🇸🇨" },
    { emoji: "🇸🇩" },
    { emoji: "🇸🇪" },
    { emoji: "🇸🇬" },
    { emoji: "🇸🇭" },
    { emoji: "🇸🇮" },
    { emoji: "🇸🇰" },
    { emoji: "🇸🇱" },
    { emoji: "🇸🇲" },
    { emoji: "🇸🇳" },
    { emoji: "🇸🇴" },
    { emoji: "🇸🇷" },
    { emoji: "🇸🇸" },
    { emoji: "🇸🇹" },
    { emoji: "🇸🇻" },
    { emoji: "🇸🇽" },
    { emoji: "🇸🇾" },
    { emoji: "🇸🇿" },
    { emoji: "🇹🇦" },
    { emoji: "🇹🇨" },
    { emoji: "🇹🇩" },
    { emoji: "🇹🇫" },
    { emoji: "🇹🇬" },
    { emoji: "🇹🇭" },
    { emoji: "🇹🇯" },
    { emoji: "🇹🇰" },
    { emoji: "🇹🇱" },
    { emoji: "🇹🇲" },
    { emoji: "🇹🇳" },
    { emoji: "🇹🇴" },
    { emoji: "🇹🇷" },
    { emoji: "🇹🇹" },
    { emoji: "🇹🇻" },
    { emoji: "🇹🇼" },
    { emoji: "🇹🇿" },
    { emoji: "🇺🇦" },
    { emoji: "🇺🇬" },
    { emoji: "🇺🇸" },
    { emoji: "🇺🇾" },
    { emoji: "🇺🇿" },
    { emoji: "🇻🇦" },
    { emoji: "🇻🇨" },
    { emoji: "🇻🇪" },
    { emoji: "🇻🇬" },
    { emoji: "🇻🇮" },
    { emoji: "🇻🇳" },
    { emoji: "🇻🇺" },
    { emoji: "🏴󠁧󠁢󠁷󠁬󠁳󠁿" },
    { emoji: "🇼🇫" },
    { emoji: "🇼🇸" },
    { emoji: "🇽🇰" },
    { emoji: "🇾🇪" },
    { emoji: "🇾🇹" },
    { emoji: "🇿🇦" },
    { emoji: "🇿🇲" },
    { emoji: "🇿🇼" },
]; 

export const SMILEYS_PEOPLE_LIST = SMILEYS_PEOPLE;
export const ANIMALS_NATURE_LIST = ANIMALS_NATURE;
export const FOOD_DRINK_LIST = FOOD_DRINK;
export const ACTIVITY_LIST = ACTIVITY;
export const TRAVEL_PLACES_LIST = TRAVEL_PLACES;
export const OBJECTS_LIST = OBJECTS;
export const SYMBOLS_LIST = SYMBOLS;
export const FLAGS_LIST = FLAGS;

export const getEmoji = (index, sub) => {
    if(sub==='SMILEYS_PEOPLE') return ((SMILEYS_PEOPLE[index] && SMILEYS_PEOPLE[index].emoji) || '');
    if(sub==='ANIMALS_NATURE') return ((ANIMALS_NATURE[index] && ANIMALS_NATURE[index].emoji) || '');
    if(sub==='FOOD_DRINK') return ((FOOD_DRINK[index] && FOOD_DRINK[index].emoji) || '');
    if(sub==='ACTIVITY') return ((ACTIVITY[index] && ACTIVITY[index].emoji) || '');
    if(sub==='TRAVEL_PLACES') return ((TRAVEL_PLACES[index] && TRAVEL_PLACES[index].emoji) || '');
    if(sub==='OBJECTS') return ((OBJECTS[index] && OBJECTS[index].emoji) || '');
    if(sub==='SYMBOLS') return ((SYMBOLS[index] && SYMBOLS[index].emoji) || '');
    if(sub==='FLAGS') return ((FLAGS[index] && FLAGS[index].emoji) || '');
    return '';
}